// modules/land-and-sale/Masterplan.js
import React            from 'react';
import $                from 'jquery';
import { browserHistory } from 'react-router';
import PlanButton       from './elements/PlanButton';
import PlanDisplay      from './elements/PlanDisplay';
import SiteDownloads    from '../common/SiteDownloads';
import PageLoading      from '../PageLoading';
import LandSearchBar	from './elements/LandSearchBar';

import '../App.css';

import Messenger        from '../common/Messenger';
let messenger 			= new Messenger();

const sources = require('../config.json');

class Masterplan extends React.Component {
	constructor(props) {
		super(props);

		this.masterplan_url = sources.masterplan;

		this.state = {
			data: {
			}
		};

		this.receivedMasterplanData = this.receivedMasterplanData.bind(this);
		this.eachElementButton      = this.eachElementButton.bind(this);
		this.planDisplay      		= this.planDisplay.bind(this);
        this.onSearchClick      		= this.onSearchClick.bind(this);
	}

	componentDidMount() {
		$.ajax({url:this.masterplan_url,dataType:'json'}).done(this.receivedMasterplanData);
	}

    onSearchClick(frontage, land, url) {
        url = url + '?frontage='+frontage.start+'&frontage='+frontage.end+'&land='+land.start+'&land='+land.end;
        browserHistory.push(url);
    }

	receivedMasterplanData(data, status, xhr) {
        if (typeof data.plan === 'undefined') data.plan = [];
        if (typeof data.elements === 'undefined') data.elements = [];

        let newState = Object.assign(this.state, {
            data: data
        });
        this.setState(newState);
		if (data.elements.length === 1) {
			// jump the masterplan if we have only 1 precinct
			this.skipMasterplan(data.elements[0].link);
		} else {
			if (typeof data.plan === 'undefined') data.plan = [];
			if (typeof data.elements === 'undefined') data.elements = [];

			let newState = Object.assign(this.state, {
				data: data
			});
			this.setState(newState);
		}
	}

	skipMasterplan(link) {
		browserHistory.push(link);
	}

	eachElementButton(element) {
		if (element.length !== 0) {
			return (
				<PlanButton
					key={element.id}
					id={element.id}
					messenger={messenger}
					buttonlink={element.link}
					buttonclass={element.class}
					buttonaction="Click To View">
					{element.name}
				</PlanButton>
			)
		}
	}

	planDisplay(data) {
		if (typeof data.plan.plan_id !== "undefined") {
			return (
				<PlanDisplay key={data.plan.plan_id} messenger={messenger} plan={data.plan} elements={data.elements} plantype="masterplan">Estate Plan</PlanDisplay>
			)
		}
	}

	render() {
		if (typeof this.state.data.plan !== "undefined") {
			return (
				<div className="App">
					<section className="section p-t-2">
						<div className="container">
							<div className="section__content tc">
								<h1 className="title f3 f4-md f-headline-lg m-b-4 m-b-4-md">Land For Sale</h1>
								<LandSearchBar onSearchClick={this.onSearchClick} onResetClick={null} search={this.props.location.query} divClass="filter release__filter js-accordion open"/>
							</div>
						</div>
					</section>
					<section className="section p-h-1 p-h-3-lg section-bg-white land-filter-section">
						<div className="container">
							<div className="cf top-land-filter-section  m-b-3-lg m-b-1">
								<div className="w-100 w-70-lg fr-lg">{this.planDisplay(this.state.data)}</div>

								<div className="w-100 w-30-lg fr-lg">
									<p className="m-b-0 p-a-1 brd-top small-blue-font tc tl-md">PRECINCTS</p>
									<ul className="">
										{this.state.data.elements.map(this.eachElementButton)}
									</ul>
								</div>
							</div>
							<SiteDownloads  divClass="cf p-a-1 btm-land-filter-section m-b-3-lg m-b-1"/>
						</div>
					</section>
				</div>
			);
		} else {
			return (
				<PageLoading>Masterplan</PageLoading>
			)
		}

	}
}

export default Masterplan;



/** WEBPACK FOOTER **
 ** ./src/modules/land-for-sale/Masterplan.js
 **/